<script setup>
import {onMounted} from 'vue'
import {State, go} from '@/paks/vu-app'
import {onBeforeMount, onUnmounted} from 'vue'
import {fixShadow} from '@/paks/vu-app'
import {Dash} from '@/paks/vu-dash'

onBeforeMount(async () => {
    fixShadow()
})

onMounted(() => {
    if (!State.app.context.deviceId) {
        go({name: 'claim'})
    }
})

onUnmounted(() => {
    fixShadow()
})
</script>

<template>
    <div class="home">
        <Dash />
    </div>
</template>

<style lang="scss">
.home {
    height: 100%;
    overflow-x: scroll;
}
</style>